import {
  EnergyBasketFragment,
  EnergyFuelType,
  EnergyMeterType,
} from '@generated/gql/graphql';
import { SignupEnergyAddedToBasketEventContext } from '@tracking/trackingEvents';

import { hasPrepaymentMeter } from '../utils';

const remapFuelType = (fuelType: EnergyFuelType) => {
  if (fuelType === EnergyFuelType.DualFuel) return 'Dual';
  if (fuelType === EnergyFuelType.ElectricityOnly) return 'ElectricityOnly';
  if (fuelType === EnergyFuelType.GasOnly) return 'GasOnly';
  return '';
};

const parseEnergyTrackingContext = (
  energy: EnergyBasketFragment
): SignupEnergyAddedToBasketEventContext => {
  const { details, fuelType, selectedQuote } = energy;
  const { gasUsage, predefinedConsumption, electricityUsageDay, meterType } =
    details;

  return {
    fuel_type: remapFuelType(fuelType as EnergyFuelType),
    energy_usage_category: predefinedConsumption,
    energy_tariff_type: selectedQuote?.name ?? '',
    custom_electricity_usage_kwh: electricityUsageDay ?? undefined,
    custom_gas_usage_kwh: gasUsage ?? undefined,
    prepayment_meter: hasPrepaymentMeter(details),
    econ_seven_meter: meterType === EnergyMeterType.Economy_7,
  };
};

export { parseEnergyTrackingContext };
